import { render, staticRenderFns } from "./historial-de-cambios-de-jefe.vue?vue&type=template&id=3adf9bc4&"
import script from "./historial-de-cambios-de-jefe.vue?vue&type=script&lang=ts&"
export * from "./historial-de-cambios-de-jefe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports